import { FC } from 'react';
import { useParams } from 'react-router';

import { useRouter } from '@cvt/routing';

import { EditMeetingPartial } from '../partials/EditMeetingPartial';


export const EditMeeting: FC = () => {
  const { meetingId } = useParams();
  const router = useRouter();

  if (!meetingId) {
    router.meetings.go();
    return null;
  }

  return (
    <EditMeetingPartial meetingId={parseInt(meetingId, 10)}/>
  );
};
